// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handlePathsImport } from 'redux/modules/projectSummary'
import { PATH_DATABASE_IMPORT } from 'components/ProjectSummary/ModalContainer/ImportWrapper/constants'

// this component sits outside the <AdvancedSearchWrapper />
// but will 'disappear' when the wrapper is open so the user
// can use the import button in there. (which is the more common place for it.)

// this is a pretty unique one-off situation here.
// if we need this behavior to be easily reproducible,
// this should be refactored to align with that.

// NOTE - this.state is used as the components style object.

class OuterImport extends React.Component {
  static propTypes = {
    handlePathsImport: func.isRequired,
    highlightedRows: array.isRequired,
    idRoot: string.isRequired,
    showOuterImport: bool.isRequired,
    sourceForm: string.isRequired,
  }

  state = {
    opacity: 0,
    pointerEvents: 'none',
    position: 'relative',
    transform: 'translate3d(0, 0, 0)',
    transition: 'opacity .3s ease',
  }

  componentDidMount () {
    this.toggleButtonStyle(this.props.showOuterImport)
  }

  componentWillReceiveProps (np) {
    // we only want to update state if the advanced wrapper has been toggled.
    if (np.showOuterImport === this.props.showOuterImport) {
      return
    }

    this.toggleButtonStyle(np.showOuterImport)
  }

  wrapperStyles = {
    float: 'right',
    top: 0,
    width: 'calc(12% - 4px)',
  }

  buttonClasses = () => {
    const base = 'btn search-button big-button display-block create-button'
    const layout = 'pull-right margin-right-1 margin-top-half'
    const interact = (
      !this.props.highlightedRows.length
        ? 'cursor-not-allowed bg-grey-dark'
        : 'bg-blue'
    )

    return `${base} ${layout} ${interact}`
  }

  importHighlightedPaths = () => {
    const {
      handlePathsImport,
      highlightedRows,
    } = this.props

    if (!highlightedRows.length) {
      return
    }

    return handlePathsImport(highlightedRows, PATH_DATABASE_IMPORT)
  }

  toggleButtonStyle = show => {
    const opacity = show ? 1 : 0
    const pointerEvents = show ? 'auto' : 'none'
    this.setState(() => ({
      opacity,
      pointerEvents,
    }))
  }

  render () {
    const {
      idRoot,
    } = this.props

    return (
      <div
        className={'database-search-actions'}
        style={this.wrapperStyles}>
        <a
          id={`${idRoot}-outer-import`}
          className={this.buttonClasses()}
          onClick={this.importHighlightedPaths}
          style={this.state}>
          {'Import'}
        </a>
      </div>
    )
  }
}

const mapStateToProps = ({ form }, { sourceForm }) => {
  const { advancedSearch } = form[sourceForm].values
  const showOuterImport = !advancedSearch.length

  return {
    showOuterImport,
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    handlePathsImport,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OuterImport)
